function dateValue(date) {
  return new Date(`${date}T12:00:00`).getTime();
}

function calculateTraditionAttendance({
  employeeSlug,
  employeeName,
  employmentWindow,
  attendedEvents,
  attendanceSource,
  eventDates,
}) {
  const startTime = dateValue(employmentWindow.startDate);
  const endTime = employmentWindow.endDate
    ? dateValue(employmentWindow.endDate)
    : Number.POSITIVE_INFINITY;
  const eligibleEvents = eventDates.filter((eventDate) => {
    const eventTime = dateValue(eventDate);
    return eventTime >= startTime && eventTime <= endTime;
  }).length;
  const safeAttendedEvents = Math.min(Math.max(attendedEvents, 0), eligibleEvents);
  const missedEvents = Math.max(eligibleEvents - safeAttendedEvents, 0);
  const attendancePercentage = eligibleEvents > 0
    ? Number(((safeAttendedEvents / eligibleEvents) * 100).toFixed(1))
    : 0;

  return {
    employeeSlug,
    employeeName,
    startDate: employmentWindow.startDate,
    endDate: employmentWindow.endDate,
    eligibleEvents,
    attendedEvents: safeAttendedEvents,
    missedEvents,
    attendancePercentage,
    attendanceSource,
  };
}

function resolveAttendanceOverride(employeeSlug, generatedCount, overrides = []) {
  const override = overrides.find((item) => item.employeeSlug === employeeSlug);
  return override
    ? { attendedEvents: override.attendedEvents, attendanceSource: 'manual-override' }
    : { attendedEvents: generatedCount, attendanceSource: 'timesheet' };
}

function sortAttendanceRecords(records, minimumEligibleEvents = 10) {
  const ranked = records.filter((record) => record.eligibleEvents >= minimumEligibleEvents)
    .sort((a, b) => b.attendancePercentage - a.attendancePercentage
      || b.attendedEvents - a.attendedEvents
      || a.employeeName.localeCompare(b.employeeName));
  const rankBySlug = new Map();
  let previousPercentage = null;
  let currentRank = 0;
  ranked.forEach((record, index) => {
    if (record.attendancePercentage !== previousPercentage) currentRank = index + 1;
    rankBySlug.set(record.employeeSlug, currentRank);
    previousPercentage = record.attendancePercentage;
  });
  return [...records].sort((a, b) => {
    const aRank = rankBySlug.get(a.employeeSlug) || Number.POSITIVE_INFINITY;
    const bRank = rankBySlug.get(b.employeeSlug) || Number.POSITIVE_INFINITY;
    return aRank - bRank || a.employeeName.localeCompare(b.employeeName);
  }).map((record) => ({
    ...record,
    rank: rankBySlug.get(record.employeeSlug) || null,
    rankingLabel: rankBySlug.has(record.employeeSlug)
      ? `#${rankBySlug.get(record.employeeSlug)}`
      : `${minimumEligibleEvents - record.eligibleEvents} eligible Friday${minimumEligibleEvents - record.eligibleEvents === 1 ? '' : 's'} until leaderboard eligibility`,
  }));
}

function shouldShowMattFirstAppearance(record) {
  return record.employeeSlug === 'matt-g' && record.attendedEvents === 0;
}

module.exports = {
  calculateTraditionAttendance,
  resolveAttendanceOverride,
  shouldShowMattFirstAppearance,
  sortAttendanceRecords,
};
